import React from 'react';
import { ctaLink } from '../data/mock';
import { Send } from 'lucide-react';

const CTASection = () => {
  const handleCTAClick = () => {
    if (window.fbq) {
      window.fbq('track', 'Subscribe');
    }
  };

  return (
    <section className="bg-[#191919] py-[50px] px-[25px] md:py-[75px] md:px-[75px] lg:py-[100px] lg:px-[100px]">
      <div className="max-w-4xl mx-auto text-center">
        {/* Main Headline - Dramatic */}
        <h2 className="text-5xl md:text-7xl lg:text-8xl font-black text-[#F8F8F8] mb-10 tracking-tight leading-tight">
          Langkah Pertama: <span className="text-[#33CCCC]">Telegram.</span>
        </h2>

        {/* No Requirements - Stacked Dramatically - Tighter spacing */}
        <div className="space-y-2 mb-10">
          <div className="border-b border-[#F8F8F8]/10 pb-2">
            <p className="text-xl md:text-2xl text-[#F8F8F8]/60 font-medium">
              Tak perlu bayar apa-apa lagi.
            </p>
          </div>
          <div className="border-b border-[#F8F8F8]/10 pb-2">
            <p className="text-xl md:text-2xl text-[#F8F8F8]/60 font-medium">
              Tak perlu isi form panjang.
            </p>
          </div>
          <div className="pb-2">
            <p className="text-xl md:text-2xl text-[#F8F8F8]/60 font-medium">
              Tak perlu bagi kad kredit.
            </p>
          </div>
        </div>

        {/* What To Do - Stacked Dramatically - Tighter spacing */}
        <div className="bg-[#F8F8F8]/5 rounded-3xl p-6 md:p-10 mb-10">
          <div className="space-y-2">
            <p className="text-2xl md:text-4xl lg:text-5xl text-[#F8F8F8] font-black tracking-tight">
              Masuk channel.
            </p>
            <p className="text-2xl md:text-4xl lg:text-5xl text-[#F8F8F8] font-black tracking-tight">
              Tengok signal.
            </p>
            <p className="text-2xl md:text-4xl lg:text-5xl text-[#33CCCC] font-black tracking-tight">
              Observe community.
            </p>
          </div>
        </div>

        {/* Stay or Leave - Big Dramatic - Tighter spacing */}
        <div className="space-y-3 mb-12">
          <p className="text-3xl md:text-5xl text-[#FF6699] font-black">
            Rasa macam tempat anda? Stay.
          </p>
          <p className="text-xl md:text-2xl text-[#F8F8F8]/50 font-medium">
            Rasa tak kena? Leave. No hard feelings.
          </p>
        </div>

        {/* CTA Button - Bigger */}
        <div className="mb-6">
          <a
            href={ctaLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleCTAClick}
            className="inline-flex items-center gap-3 bg-[#33CCCC] hover:bg-[#2ab8b8] text-[#191919] font-bold text-lg md:text-xl px-10 py-4 rounded-full transition-all duration-300 transform hover:scale-105"
          >
            <Send className="w-5 h-5 md:w-5 md:h-5" />
            MASUK TELEGRAM
          </a>
        </div>

        {/* Assurance */}
        <p className="text-lg md:text-xl text-[#F8F8F8]/40 font-medium">
          Free. Takde spam. Boleh keluar bila-bila.
        </p>
      </div>
    </section>
  );
};

export default CTASection;
